export const KEY = 'partnerWebsites';

export const PARTNER_WEBSITES = 'partnerWebsites';
export const PARTNER_WEBSITES_STATUS = 'partnerWebsitesStatus';
export const EDITED_PARTNER_WEBSITE = 'editedPartnerWebsite';
export const PARTNER_WEBSITE_CREATE_STATUS = 'partnerWebsiteCreateStatus';
export const PARTNER_WEBSITE_EDIT_STATUS = 'partnerWebsiteEditStatus';
export const PARTNER_WEBSITE_DELETE_STATUS = 'partnerWebsiteDeleteStatus';
